import PurchaseValue from '../PurchaseValue';
import StockIssues from '../StockIssues';
import StockReceipt from '../StockReceipt';
import StockTakeReconciliation from '../StockTakeReconciliation';
import TotalBatchProductionValue from '../TotalbatchProductionValue';

interface IInventorySubRBaseLayoutProps {
  widget: string | undefined;
}

const InventorySubRBaseLayout = ({ widget }: IInventorySubRBaseLayoutProps) => {
  switch (widget) {
    case 'total-batch-production-value':
      return <TotalBatchProductionValue />;
    case 'stock-take-reconciliation':
      return <StockTakeReconciliation />;
    case 'purchase-value':
      return <PurchaseValue />;
    case 'stock-receipt':
      return <StockReceipt />;
    case 'stock-issues':
      return <StockIssues />;
    default:
      return null;
  }
};

export default InventorySubRBaseLayout;
